<template lang="pug">
    include SportsFacilitiesList.pug
</template>

<script>
import { mapState } from 'vuex';
import Api from './../services/Api'

export default {
  name: 'SportsFacilitiesList',
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      page: 1,
      hasPrevious: false,
      hasNext: false,
      totalPages: 0,
      pages: [],
      facilities: [],
    }
  },
  created() {
    this.search()
  },
  methods: {
    nextPage() {
      if (!this.hasNext) return false
      this.page += 1
      this.search(true, true)
    },
    prevPage() {
      if (!this.hasPrevious) return false
      this.page -= 1
      this.search(true, true)
    },
    toPage(page) {
      this.page = page
      this.search(true, true)
    },
    search() {
      const _this = this

      let filters = this.buildFilters()
      filters.page = this.page
      document.body.scrollTop = document.documentElement.scrollTop = 0

      Api.facilities(filters).then(response => {
        let data = response.data

        _this.hasPrevious = response.data.has_previous
        _this.hasNext = response.data.has_next
        _this.totalPages = response.data.total_pages

        let pagesList = []

        for (var i = 1; i <= _this.totalPages; i++) {
          pagesList.push(i)
        }
        _this.pages = pagesList
        _this.facilities = response.data.items
      }).catch(err => {
      })
    },
    buildFilters() {
      let filters = {}
      if (this.query && this.query.length) filters['query'] = this.query
      return filters
    },
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@import '../Trainer';
@import "SportsFacilitiesList";

</style>



// WEBPACK FOOTER //
// src/components/sports_facilities_list/SportsFacilitiesList.vue